module.exports = __webpack_public_path__ + "img/manage08.228762c1.png";